<template>
  <v-row justify="space-between" class="location-row">
    <div class="location-box">
      <div class="icon__background">
        <v-icon color="primary lighten-1" size="24">mdi-map-marker-radius-outline</v-icon>
      </div>
      <span class="H6">{{ getTextTranslation(location.name) }}</span>
    </div>
    <div class="img">
      <v-icon class="img-icon" @click="showLocationImage = true">mdi-magnify</v-icon>
      <v-img
        class="border-radius--10"
        width="67"
        height="50"
        :src="location.imageFile"
      />
    </div>
    <preview-images 
      :show="showLocationImage" 
      @close="showLocationImage = false" 
      :images="[location.imageFile]" 
      :initialSlide="0"
    />
  </v-row>
</template>
<script>
import { getTextValue } from '@/lib/helpers/LocalizedText'

export default {
  data () {
    return {
      showLocationImage: false,
    }
  },
  props: {
    location: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getTextTranslation (LocalizedText) {
      return getTextValue(LocalizedText)
    },
  },
  components: {
    PreviewImages: () => import('@/components/app-components/PreviewImages.vue'),
  },
}
</script>
<style scoped>
.location-row {
  padding: 5px 12px 0px;
}

.location-box {
  display: flex;
  align-items: center;
  gap: 12px;
}

.img {
  position: relative;
}

.img-icon {
  top: 50%;
  left: 50%;
  position: absolute !important;
  transform: translate(-50%, -50%);
  z-index: 3;
  background-color: rgba(255, 255, 255, 0.5);
  color: rgba(255, 255, 255, 0.9) !important;
  padding: 1px;
  border-radius: 12px;
}

.border-radius--10 {
  border-radius: 10px;
}
</style>